module.exports = __webpack_public_path__ + "assets/favicon-bf-fr.a5f127dd.png";